<div class="h-screen w-screen">
    <router-outlet></router-outlet>
</div>
<div *ngIf="this.loadingService.loadingStatus() | async" class="SpinnerDivMain">
    <div class="SpinnerDivBox">
        <div class="spinner">
        </div>
        <i class="fa-solid fa-bars icn"></i>
    </div>
</div>
